import { IconButton, Snackbar } from '@material-ui/core';
import { Close } from '@material-ui/icons';
import React from 'react';
import { SharedSnackbarConsumer } from '../context/SnackbarContext';
const SharedSnackbar = () => (
  <SharedSnackbarConsumer>
    {({ snackbarIsOpen, message, closeSnackbar }) => (
      <Snackbar
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        open={snackbarIsOpen}
        autoHideDuration={4000}
        onClose={closeSnackbar}
        message={message}
        action={[
          <IconButton key='close' color='inherit' onClick={closeSnackbar}>
            <Close />
          </IconButton>,
        ]}
      ></Snackbar>
    )}
  </SharedSnackbarConsumer>
);

export default SharedSnackbar;